<template>
	<a href="javascript:;" 
		@click.prevent="handleClick" 
		class="btn btn-danger btn-back page-action"
		:disabled="disabled">
		<i class="fa fa-chevron-left"></i> Kembali
	</a>
</template>

<script>
import { warningPrompt } from '../helpers'
export default {
	methods: {
		handleClick() {
			if (!this.displayWarning) {
				this.clickHandler(this.$router)
				return
			}

			warningPrompt({
				title: this.warningTitle,
				text: this.warningText,
				onConfirm: () => {
					this.clickHandler(this.$router)
				}
			})
		}
	},
	props: {
		clickHandler: {
			type: Function,
			required: false,
			default: router => router.go(-1),
		},
		disabled: {
			type: Boolean,
			required: false,
			default: false,
		},
		displayWarning: {
			type: Boolean,
			required: false,
			default: true,
		},
		warningText: {
			type: String,
			required: false,
			default: 'Data yang Anda input di halaman ini akan hilang, yakin untuk pindah halaman?',
		},
		warningTitle: {
			type: String,
			required: false,
			default: 'Anda akan berpindah halaman',
		},
	}
}
</script>
